"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Intervals = void 0;
exports.createSubscription = createSubscription;
exports.deleteSubscription = deleteSubscription;
exports.editSubscription = editSubscription;
exports.getLocations = getLocations;
exports.getSubscriptions = getSubscriptions;
var _RestHelper = _interopRequireWildcard(require("../../utils/RestHelper"));
var _config = _interopRequireDefault(require("../config/config"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */

var URL_RESOURCE_SUBSCRIPTIONS = '/api/consumption/v0/subscriptions';
var Intervals = exports.Intervals = /*#__PURE__*/function (Intervals) {
  Intervals["DAILY"] = "DAILY";
  Intervals["WEEKLY"] = "WEEKLY";
  Intervals["MONTHLY"] = "MONTHLY";
  return Intervals;
}({});
function getLocations() {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/consumption/v0/locations?activeOnly=true"), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
}

/**
 * - Get a single or list of subscriptions
 * An empty list is returned if no subscriptions are found.
 */
function getSubscriptions(/* subscriptionId */
) {
  /*
  if (subscriptionId) {
    return RestHelper.get(
      `${RestHelper.getBaseUrl(MWDomains.cicCustomer)}${urlSubscriptions}/${subscriptionId}`,
    );
  }
  */

  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer)).concat(URL_RESOURCE_SUBSCRIPTIONS), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
}

/**
 * - Creates a new subscription
 * ️️️️️The locations available for creating a new load shape
 * subscription can be obtained using the "getLocations()" API.
 */
function createSubscription(data) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer)).concat(URL_RESOURCE_SUBSCRIPTIONS), data, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
}

/**
 * - Edit an existing subscription
 */
function editSubscription(subscriptionId, data) {
  return _RestHelper.default.put("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer)).concat(URL_RESOURCE_SUBSCRIPTIONS, "/").concat(subscriptionId), data, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
}

/**
 * - Delete an existing subscription
 * The subscription to delete is identified by the target URI (subscriptionId).
 */
function deleteSubscription(subscriptionId) {
  return _RestHelper.default.delete("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer)).concat(URL_RESOURCE_SUBSCRIPTIONS, "/").concat(subscriptionId), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
}